'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('survey-results', {
      url: '/admin/survey/results/:id',
      template: '<survey-result></survey-result>',
        authenticate: 'admin'
    });
}



// WEBPACK FOOTER //
// ./client/app/survey/result/survey-result.routes.js